import type { FC } from 'react'

import { StyledText, Button } from '@skytech/ui'
import BackIcon from 'mdi-react/ArrowLeftIcon'
import { useNavigate } from 'react-router-dom'

import { Translation } from '@/components/i18n/Translation'
import Page from '@/components/page/Page'
import { APP_ROUTES } from '@/util/appRoutes'

import { OrderList } from './OrderList'

export const Orders: FC = () => {
  const navigate = useNavigate()

  return (
    <Page pageWrapperClassName="max-w-full xl:pr-4">
      <div className="text-center">
        <StyledText colorMode="black" fontWeight="bold" size="large">
          <Translation id="Dine ordre" />
        </StyledText>
      </div>

      <OrderList />

      <Button
        className="mobile:min-w-32 mx-0 min-w-full"
        onClick={() => navigate(APP_ROUTES.ecomPolicyList)}
        Icon={<BackIcon />}
      >
        <Translation id="Back to shop" />
      </Button>
    </Page>
  )
}
